import * as React from "react";
import arrowIcon from '../../assets/dropdown.svg';
import { SelectorProps, SelectorState } from "./type";
import { ElementUtility } from "../../utils/ElementUtility";
import "./style.css";

export class Selector extends React.Component<SelectorProps, SelectorState> {
  constructor(props: SelectorProps) {
    super(props);

    this.state = {
      isFocus: false
    };
  }

  componentDidMount() {
    document.addEventListener('click', event => this.handleClickEvent(event));
  }

  render() {
    const { id, name, title, translator, selected, options, onSelectOption } = this.props;
    const filteredOptions = options.filter(value => value !== selected);

    return (
      <div id={id} className="selector" >
        <div className="selector__display" onClick={() => this.handleToggleSelector()}>
          <p className="selector--selected">
            {translator ? translator[selected] : selected}
          </p>
          <img className="selector__indicator" src={arrowIcon} alt="" />
        </div>
        <div className={`selector__options ${this.state.isFocus ? "show" : ""}`}>
          {this.renderOptions(id, name, filteredOptions, onSelectOption, translator)}
        </div>
        {
          title ?
          <p className="selector__title">{title}</p> :
          null
        }
      </div>
    );
  }

  renderOptions(
    id: string,
    name: string,
    options: string[],
    onSelectOption: (name: string, value: string) => void,
    translator?: {[key: string]: any}
  ) {
    return options.map((option, index, optionList) => {
      return (
        <div
          id={`${id}--${index}`}
          key={`${id}--${index}`}
          className={`selector__option ${index === 0 ? 'first': optionList.length - 1 === index ? 'last': ''}`}
          onClick={() => {
            onSelectOption(name, option);
            this.handleToggleSelector();
          }}
        >
          {translator ? translator[option] : option}
        </div>
      );
    });
  }

  handleToggleSelector() {
    this.setState({ isFocus: this.state.isFocus ? false : true })
  }

  handleClickEvent(event: MouseEvent) {
    const element = (event.srcElement as Element);

    if (this.state.isFocus && !ElementUtility.isParentElement(element, this.props.id)) {
      this.setState({isFocus: false});
    }
  }
}